import { AppSettings, PageRoute, TranslationsMap, SaveFlowStatus } from '@src/types';
import { StoreState } from '../store';
import { IServices } from '@src/sevices/services';
import {
  setPendingAppEnabled,
  updateAppSettings,
  flushPendingChanges,
  enableAppAndSaveChanges,
  resetExpiryDate,
  cancelPendingChanges,
  updateCookiePolicyRequirement,
  disableAppAndSaveChanges,
} from './app-settings';
import { navigateTo } from './navigation/navigation';
import { updateTranslations } from './translations';
import { checkPendingChanges, setSaveStatus } from './save-status';
import { RemoveToast, ToastConfig } from '@wix/business-manager-api';
import { ValidationActions, initValidationActions } from './validations';

export interface Actions extends ValidationActions {
  disableAppAndSaveChanges(): Promise<void>;
  setPendingAppEnabled(enabled: boolean): Promise<void>;
  flushPendingChanges(): void;
  cancelPendingChanges(): void;
  updatePendingTranslations(partialPendingTranslations: Partial<TranslationsMap>): Promise<void>;
  updatePendingAppSettings(partialPendingSettings: Partial<AppSettings>): Promise<void>;
  updateCookiePolicyRequirement(requirementApproved: boolean): void;
  navigateTo(page: PageRoute): void;
  enableAppAndSaveChanges(): Promise<void>;
  resetExpiryDate(): Promise<void>;
  checkPendingChanges(): void;
  setSaveStatus(status: SaveFlowStatus): void;
  showToast(toastConfig: ToastConfig): { remove: RemoveToast };
}

export type ActionParams = {
  getState: () => StoreState;
  setState: (state: Partial<StoreState>) => Promise<any>;
  services: IServices;
};

export function initializeActions(actionParams: ActionParams): Actions {
  return {
    disableAppAndSaveChanges: disableAppAndSaveChanges(actionParams),
    setPendingAppEnabled: setPendingAppEnabled(actionParams),
    updateCookiePolicyRequirement: updateCookiePolicyRequirement(actionParams),
    updatePendingAppSettings: updateAppSettings(actionParams),
    updatePendingTranslations: updateTranslations(actionParams),
    flushPendingChanges: flushPendingChanges(actionParams),
    cancelPendingChanges: cancelPendingChanges(actionParams),
    navigateTo: navigateTo(actionParams),
    enableAppAndSaveChanges: enableAppAndSaveChanges(actionParams),
    resetExpiryDate: resetExpiryDate(actionParams),
    checkPendingChanges: checkPendingChanges(actionParams),
    setSaveStatus: setSaveStatus(actionParams),
    showToast: actionParams.services.showToast,
    ...initValidationActions(actionParams),
  };
}
